// Enter all your detials in this file
// Logo images
import logogradient from './assets/rafly_punya.jpeg';
import logo from './assets/logo2.svg';
// Profile Image
import profile from './assets/profile.png';
// Tech stack images
import kotlin from './assets/techstack/kotlin.png';
import firebase from './assets/techstack/firebase.png';
import google_cloud_console from './assets/techstack/google_cloud_console.png';
import google_play_console from './assets/techstack/google_play_console.png';
import flutter from './assets/techstack/flutter.svg';
import laravel from './assets/techstack/laravel.png';
import php from './assets/techstack/php.png';
import kmm from './assets/techstack/kmm.png';
import jetpack from './assets/techstack/jetpack_compose.png';
import postgre from './assets/techstack/postgre.png';

import android_studio from './assets/techstack/android_studio.png';
import notion from './assets/techstack/notion.png';
import trello from './assets/techstack/trello.png';
import git from './assets/techstack/git.png';
import github from './assets/techstack/github.png';
import figma from './assets/techstack/figma.png';
import vscode from './assets/techstack/vscode.png';
import postman from './assets/techstack/postman.png';
import navicat from './assets/techstack/navicat.png';
import intellij from './assets/techstack/intellij.png';
import phpstorm from './assets/techstack/phpstorm.png';
import phpmyadmin from './assets/techstack/phpmyadmin.png';
import xampp from './assets/techstack/xampp.svg';

import html from './assets/techstack/html.png';
import css from './assets/techstack/css.png';
import sass from './assets/techstack/sass.png';
import js from './assets/techstack/js.png';
import react from './assets/techstack/react.png';
import redux from './assets/techstack/redux.png';
import tailwind from './assets/techstack/tailwind.png';
import bootstrap from './assets/techstack/bootstrap.png';
import npm from './assets/techstack/npm.png';
// Porject Images
import projectImage1 from './assets/projects/phone_frame.jpg';

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: 'Rafly Yusrizal Amrie',
  tagline: 'I worked as Mobile Developer',
  img: profile,
  about: `Hi!, My Name is Rafly Yusrizal Amrie or Fly for short. But you can call me anything.\n
  I grew up in Garut and Bandung. I used to study at SMAN 11 Garut taking a Social Major and get a Associate Degree at Politeknik LP3I Bandung. I have some experience in developing android app start from scratch to complex feature in app.\n
  I really interested in tech related stuff. Right now I'm exploring and learning in Front-End Dev in Mobile and Web App using Flutter, Kotlin, Laravel, ASP.NET, C#, HTML, JAVASCRIPT, and Microsoft SQL Server. I am passionate about building excellent software that improves the lives of those around me. I do other things like playing games, airsoft or riding motorcycle.`,
};
// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: 'https://www.linkedin.com/in/rafly-amrie/',
  github: 'https://github.com/rafly-amrie/',
  instagram: 'https://www.instagram.com/rafly_dev/',
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: 'Front-End Web Developer (React.Js)',
    Company: 'PT. Sentra Teknologi Informasi',
    Location: 'Bandung',
    Type: 'Internship',
    Duration: 'Sep 2020 - Jan 2021',
  },
  {
    Position: 'Android Developer (Kotlin)',
    Company: 'PT. Teknologi Digital Abadi',
    Location: 'Bandung',
    Type: 'Full-Time',
    Duration: 'Feb 2021 - May 2023',
  },
  {
    Position: 'Android Developer (Kotlin)',
    Company: 'Inspera Media',
    Location: 'Bandung',
    Type: 'Freelance',
    Duration: 'June 2022 - June 2024',
  },
  {
    Position: 'Full-Stack Developer (Flutter, Laravel)',
    Company: 'Bank Arthaguna Mandiri',
    Location: 'Bandung',
    Type: 'Full-Time',
    Duration: 'July 2023 - Nov 2024',
  },
  {
    Position: 'Mobile Developer iOS & Android (Flutter)',
    Company: 'PT. Pioneer Inovasi Digital',
    Location: 'Bandung',
    Type: 'Freelance',
    Duration: 'Dec 2023 - Feb 2025',
  },
];

// Enter your Work Experience here
export const freelanceDetails = [
  {
    Position: 'Android Developer (Kotlin)',
    Company: 'Inspera Media',
    Location: 'Bandung',
    Type: 'Freelance',
    Duration: 'July 2022 - Recent',
  },
  {
    Position: 'Mobile Developer (Flutter)',
    Company: 'Personal',
    Location: 'Bandung',
    Type: 'Freelance',
    Duration: 'Dec 2023 - Recent',
  },
];

// Enter your Education Details here
export const eduDetails = [
  // {
  //   Position: 'Student',
  //   Company: 'TK Prima Insani',
  //   Location: 'Garut',
  //   Type: 'All Major',
  //   Duration: '2004 - 2006',
  // },
  // {
  //   Position: 'Student',
  //   Company: 'SD Kartika Siliwangi 3',
  //   Location: 'Garut',
  //   Type: 'All Major',
  //   Duration: '2006 - 2012',
  // },
  // {
  //   Position: 'Student',
  //   Company: 'SMPN 2 Garut',
  //   Location: 'Garut',
  //   Type: 'All Major',
  //   Duration: '2012 - 2015',
  // },
  {
    Position: 'Student',
    Company: 'SMAN 11 Garut',
    Location: 'Garut',
    Type: 'Social Major',
    Duration: '2015 - 2018',
  },
  {
    Position: 'Associate Degree',
    Company: 'Politeknik LP3I Bandung',
    Location: 'Bandung',
    Type: 'Informatic Management (Computer Informatic)',
    Duration: '2018 - 2021',
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  kotlin: kotlin,
  firebase: firebase,
  google_cloud_console: google_cloud_console,
  google_play_console: google_play_console,
  flutter: flutter,
  laravel: laravel,
  php: php,
  kmm: kmm,
  jetpack: jetpack,
  postgre: postgre,

  android_studio: android_studio,
  notion: notion,
  trello: trello,
  git: git,
  github: github,
  figma: figma,
  vscode: vscode,
  postman: postman,
  navicat: navicat,
  intellij: intellij,
  phpstorm: phpstorm,
  phpmyadmin: phpmyadmin,
  xampp: xampp,

  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  npm: npm,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: 'Government Agencies',
    image: projectImage1,
    description: 'Create a community service android application',
    techstack: 'Kotlin',
  },
  {
    title: 'Internal',
    image: projectImage1,
    description: 'Create a Internal Company android application',
    techstack: 'Flutter',
  },
  {
    title: 'E-Retail',
    image: projectImage1,
    description: 'Create a Retail android application',
    techstack: 'Kotlin',
  },
  {
    title: 'E-Manufactur',
    image: projectImage1,
    description: 'Create a Manufacturing android application',
    techstack: 'Flutter',
  }
];

// Enter your Contact Details here
export const contactDetails = {
  email: 'raflydevelop@gmail.com',
  phone: '+6285759505184',
};
 